import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import Button from 'components/Button'
import Tabs from 'components/Tabs'
import KanBoIcon from 'components/KanBoIcon'
import UsersAction from 'components/CardActions/Users'
import CardStatusAction from 'components/CardActions/Status'
import CardTagsAction from 'components/CardActions/Tags'
import CardDateAction from 'components/CardActions/Date'
import Scrollbars from 'components/Scrollbars'
import AddSubCard from './AddSubCard'
import NameForm from './NameForm'
import MoreActions from './MoreActions'
import classes from './QuickActions.module.scss'

export class QuickActions extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    listId: PropTypes.number.isRequired,
    close: PropTypes.func.isRequired,
    defaultSelectedTabId: PropTypes.string,

    intl: PropTypes.object.isRequired,

    card: PropTypes.element.isRequired,

    name: PropTypes.string.isRequired,
    responsible: PropTypes.number,
    users: PropTypes.array.isRequired,
    cardStatuses: PropTypes.array.isRequired,
    status: PropTypes.object,
    labels: PropTypes.array.isRequired,
    boardLabels: PropTypes.array.isRequired,
    startDate: PropTypes.number,
    dueDate: PropTypes.number,
    calendarDate: PropTypes.number,

    requestChangeCardName: PropTypes.func.isRequired,
    requestAddUserToCard: PropTypes.func.isRequired,
    requestRemoveUserFromCard: PropTypes.func.isRequired,
    requestChangeCardStatus: PropTypes.func.isRequired,
    requestAddLabelToCard: PropTypes.func.isRequired,
    requestRemoveLabelFromCard: PropTypes.func.isRequired,
    requestChangeCardStartDate: PropTypes.func.isRequired,
    requestRemoveCardStartDate: PropTypes.func.isRequired,
    requestChangeCardDueDate: PropTypes.func.isRequired,
    requestRemoveCardDueDate: PropTypes.func.isRequired
  }

  state = {
    selectedTabId: this.props.defaultSelectedTabId
  }

  handleNameFormValidate = ({ name }) => {
    const errors = {}
    if (name && name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = this.props.intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleNameFormSubmit = ({ name }) => {
    const { id, requestChangeCardName } = this.props

    if (name && name !== this.props.name) {
      requestChangeCardName({
        id,
        name
      })
    }

    this.props.close()
  }

  handleAddUser = (user) => {
    const { id, requestAddUserToCard } = this.props

    requestAddUserToCard({
      id,
      userId: user.id
    })
  }

  handleRemoveUser = (user) => {
    const { id, requestRemoveUserFromCard } = this.props

    requestRemoveUserFromCard({
      id,
      userId: user.id
    })
  }

  handleStatusClick = ({ id: statusId }) => {
    const {
      id,
      status,
      requestChangeCardStatus
    } = this.props

    if (statusId !== status.id) {
      requestChangeCardStatus({
        id,
        statusId,
      })
    }
  }

  handleTagClick = ({ id: labelId }) => {
    const {
      id,
      labels,
      requestAddLabelToCard,
      requestRemoveLabelFromCard
    } = this.props

    const selected = labels.indexOf(labelId) !== -1

    if (!selected) {
      requestAddLabelToCard({
        id,
        labelId
      })
    } else {
      requestRemoveLabelFromCard({
        id,
        labelId
      })
    }
  }

  handleStartDateChange = (date) => {
    const { id, requestChangeCardStartDate, dueDate } = this.props

    requestChangeCardStartDate({
      id,
      startDate: date
    })

    if (!dueDate) {
      this.setState({ selectedTabId: 'dueDate' })
    }
  }

  handleRemoveStartDateClick = () => {
    const { id, requestRemoveCardStartDate } = this.props

    requestRemoveCardStartDate({
      id
    })
  }

  handleDueDateChange = (date) => {
    const { id, requestChangeCardDueDate } = this.props

    requestChangeCardDueDate({
      id,
      dueDate: date
    })
  }

  handleRemoveDueDateClick = () => {
    const { id, requestRemoveCardDueDate } = this.props

    requestRemoveCardDueDate({
      id
    })
  }

  handleTabChange = (selectedTabId) => {
    this.setState({ selectedTabId })
  }

  render () {
    const {
      intl,

      card,
      listId,
      id,
      name,
      responsible,
      users,
      labels,
      cardStatuses,
      status,
      boardLabels,
      startDate,
      dueDate,
      calendarDate,
      close
    } = this.props

    const {
      selectedTabId
    } = this.state

    const tabs = [{
      id: 'name',
      title: <KanBoIcon name='kanbo-16-letter-count' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'NAME' }),
      view: (
        <Scrollbars
          className={classes.paddedContent}
        >
          <NameForm
            initialValues={{ name }}
            validate={this.handleNameFormValidate}
            onSubmit={this.handleNameFormSubmit}
          />
        </Scrollbars>
      )
    }, {
      id: 'users',
      title: <KanBoIcon name='kanbo-16-members' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'CARD_MEMBERS' }),
      view: (
        <UsersAction
          responsible={responsible}
          users={users}
          onAddUser={this.handleAddUser}
          onRemoveUser={this.handleRemoveUser}
        />
      )
    }, {
      id: 'status',
      title: <KanBoIcon name='kanbo-16-in-process' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'CARD_STATUS' }),
      view: (
        <Scrollbars>
          <CardStatusAction
            cardStatuses={cardStatuses}
            status={status}
            onStatusClick={this.handleStatusClick}
          />
        </Scrollbars>
      )
    }, {
      id: 'labels',
      title: <KanBoIcon name='kanbo-16-label' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'LABELS' }),
      view: (
        <Scrollbars>
          <CardTagsAction
            tags={boardLabels}
            selectedTags={labels}
            onTagClick={this.handleTagClick}
          />
        </Scrollbars>
      )
    }, {
      id: 'startDate',
      title: <KanBoIcon name='kanbo-16-start-date' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'CARD_START_DATE' }),
      view: (
        <Scrollbars
          className={classes.paddedContent}
        >
          {startDate &&
            <Button
              block
              style={{ textAlign: 'left', marginBottom: '10px' }}
              icon={<KanBoIcon name='kanbo-16-remove-due-date' />}
              onClick={this.handleRemoveStartDateClick}
            >
              <FormattedMessage id='REMOVE' />
            </Button>
          }
          <CardDateAction
            key='startDate'
            date={startDate ? startDate : calendarDate}
            onDateChange={this.handleStartDateChange}
          />
        </Scrollbars>
      )
    }, {
      id: 'dueDate',
      title: <KanBoIcon name='kanbo-16-due-date' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'CARD_DUE_DATE' }),
      view: (
        <Scrollbars
          className={classes.paddedContent}
        >
          {dueDate &&
            <Button
              block
              style={{ textAlign: 'left', marginBottom: '10px' }}
              icon={<KanBoIcon name='kanbo-16-remove-due-date' />}
              onClick={this.handleRemoveDueDateClick}
            >
              <FormattedMessage id='REMOVE' />
            </Button>
          }
          <CardDateAction
            key='dueDate'
            date={dueDate ? dueDate : calendarDate}
            onDateChange={this.handleDueDateChange}
          />
        </Scrollbars>
      )
    }, {
      id: 'subcard',
      title: <KanBoIcon name='kanbo-16-relation-child' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'SUBCARD_ADD' }),
      view: (
        <Scrollbars
          className={classes.paddedContent}
        >
          <AddSubCard
            cardId={id}
            listId={listId}
            close={close}
          />
        </Scrollbars>
      )
    }, {
      id: 'more',
      title: <KanBoIcon name='kanbo-16-options' style={{ fontSize: 16 }} />,
      tooltip: intl.formatMessage({ id: 'MORE' }),
      view: (
        <Scrollbars
          className={classes.paddedContent}
        >
          <MoreActions
            id={id}
            listId={listId}
            close={close}
          />
        </Scrollbars>
      )
    }]

    return (
      <div className={classes.quickActions}>
        <div className={classes.cardContainer}>
          {card}
        </div>
        <Tabs
          small
          tabContainerProps={{
            className: classes.tabContainer
          }}
          tabs={tabs}
          selectedTabId={selectedTabId}
          onTabChange={this.handleTabChange}
        />
      </div>
    )
  }
}

export default injectIntl(QuickActions)
